import { Outlet } from 'react-router-dom';

function Users(){
    return(
        <Outlet/>
    );
}

export default Users;
  